/**
 * Opcje filtra „Firma" w sekcjach kokpitu decyzji.
 *
 * Lista to firmy REKORDÓW sekcji z serwera (`companyOptions=1`), a nie firmy użytkownika; serwer liczy ją
 * bez filtrów nagłówka, więc nie zawęża się przy filtrowaniu innych kolumn. Wyjątek dotyczy firmy, która
 * została wybrana w filtrze, a po odświeżeniu zniknęła z listy (zeszły z niej ostatnie rekordy sekcji):
 * zostaje na liście z zapamiętaną nazwą, żeby filtr dało się zobaczyć i zdjąć.
 */

import type { DecisionSectionCompanyOption } from '@/lib/processes/approvals-api';

/**
 * Opcje filtra „Firma": firmy z serwera + firmy wybrane w filtrze, których serwer już nie zwraca
 * (nazwa z pamięci `labels`, a gdy jej nie ma — `unknownLabel`), w polskiej kolejności alfabetycznej.
 * Bez takich firm zwraca `options` bez zmian (ta sama referencja).
 */
export function mergeSelectedCompanies(
  options: readonly DecisionSectionCompanyOption[],
  selectedIds: readonly string[],
  labels: ReadonlyMap<string, string>,
  unknownLabel: string,
): readonly DecisionSectionCompanyOption[] {
  const listed = new Set(options.map((option) => option.id));
  const missing = selectedIds
    .filter((id) => !listed.has(id))
    .map((id): DecisionSectionCompanyOption => ({ id, name: labels.get(id) ?? unknownLabel }));
  if (missing.length === 0) return options;
  return [...options, ...missing].sort((a, b) => a.name.localeCompare(b.name, 'pl'));
}
